import { LottieAnimationData, MediaAsset } from '@/libs/contentful/types';

/**
 * Width cap for fixed 48–72px slots that rely on next/image's 1x/2x srcset: picks 256w at 1x and 640w at 2x+.
 * Sources closer to the drawn size blur glossy renders and alias fine prints at q=50.
 */
export const FIXED_SLOT_SOURCE_WIDTH = 256;

export function isValidAnimation(lottie?: LottieAnimationData | null) {
  if (!lottie) return false;
  return !!Object.keys(lottie).length;
}

export function capMediaWidth(media: MediaAsset, maxWidth: number): MediaAsset {
  if (!media.width || !media.height || media.width <= maxWidth) return media;
  return { ...media, width: maxWidth, height: Math.round((media.height * maxWidth) / media.width) };
}
